import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { popupOpenService } from '../../shared/popupOpenService';
import { POPUP_KEY_DELETE_INGREDIENT, RECIPE_INGREDIENT_GROUP_TASTY } from '../../constant';
import { productsService } from '../../services/productsService';
import { TrashIcon } from '../../appearence/icons/trash_icon';
import { XIcon } from '../../appearence/icons/x_icon';
import FormsHandler from '../formStructure/FormsHandler';
import { createFormsIngredientService } from '../../services/formsIngredientService';
import { recipeSaveService } from '../../services/recipeSaveService';
import {PreferenceType} from "../../services/preferenceTypes";
import { HeatTreatment } from '../../services/recipeTypes';
import {IconWrapper} from "../../appearence/icons/icon_wrapper";
import { Input, Select } from '@chapche/ui';

const AMOUNT_KINDS = ['teaspoon', 'pinch', 'to_taste', 'gram'];
const HEAT_TREATMENTS = Object.values(HeatTreatment);

const IngredientsListItem = ({ingredient}) => {
    const { i18n } = useTranslation();
    const [recipeIsChanged, setRecipeIsChanged] = useState(null);

    const changeRecipe = () => {
        setRecipeIsChanged(!recipeIsChanged);
    };

    useEffect(() => {
        recipeSaveService.registerItemUpdateObserver(changeRecipe);
        return () => {
            recipeSaveService.unRegisterItemUpdateObserver(changeRecipe);
        };
    }, []);

    const isTasty = ingredient.ingredientGroup === RECIPE_INGREDIENT_GROUP_TASTY;

    return (
        <li className="recipe__add-item" key={ingredient.id + "ingredient"}>
            <h3 className='block__text recipe__add-title' >
                <span className="product__form-label_text">
                    {ingredient.ingredientType === PreferenceType.CEREAL_MIX ?
                        i18n.t('preference.scheme.preferenceType.cereal-mix')
                        : 
                        i18n.t('app.page.recipe.product')}
                </span>
                <span onClick={() => popupOpenService.callToOpen(POPUP_KEY_DELETE_INGREDIENT, ingredient.id)}>
                    <IconWrapper><TrashIcon/></IconWrapper>
                </span>
            </h3>
            {ingredient.ingredientType === PreferenceType.CEREAL_MIX ?
                <label className="block__text product__form-label">
                    <div>
                        <div className="product__forms">
                            <label className="block__text recipe__form-label recipe__add-label">
                                <ul className="product__forms-list product__forms-list_full-width">
                                    {ingredient.ingredientParts.map(it => (
                                        <li key={it.id + 'selected'} className="product__forms-item">
                                            <span className="block__bullet product__forms-text">
                                                {productsService.getLocalization(i18n.resolvedLanguage, it.productCode, true)}
                                            </span>
                                            <XIcon nameOfClass="product__forms-item-icon" />
                                        </li>
                                    ))}
                                </ul>
                            </label>
                        </div>
                    </div>
                </label>
                :
                <label className="block__text recipe__form-label recipe__add-label">
                    <Input
                        fullWidth
                        className="mt-0"
                        disabled
                        value={productsService.getLocalization(i18n.resolvedLanguage, ingredient?.ingredientParts[0]?.productCode, true)}
                        onChange={() => {}}
                        placeholder={i18n.t('app.page.recipe.productCode')} />
                </label>}
            {!isTasty ? (
                <>
                <label className="block__text recipe__form-label recipe__add-label">
                    <span className="product__form-label_text">{i18n.t('app.page.recipe.heatTreatment')}</span>
                    <Select
                        fullWidth
                        className="mt-0"
                        value={ingredient?.ingredientParts?.[0]?.heatTreatment || ''}
                        onChange={(value) => recipeSaveService.updateIngredientProportion(ingredient.id, {
                            ingredientParts: [{
                                ...ingredient.ingredientParts[0],
                                heatTreatment: value || null,
                            }],
                        })}
                        options={[
                            { value: '', label: i18n.t('app.page.recipe.heatTreatment.none') },
                            ...HEAT_TREATMENTS.map((value) => ({
                                value,
                                label: i18n.t(`app.page.recipe.heatTreatment.${value}`),
                            })),
                        ]}
                    />
                </label>
                <label className="block__text recipe__form-label recipe__add-label">
                    <span className="product__form-label_text">{i18n.t('app.page.recipe.unitWeight')}</span>
                    <Input
                        fullWidth
                        className="mt-0"
                        type="number"
                        min={0.1}
                        step={0.1}
                        value={ingredient.unitWeight ?? 1}
                        onChange={(e) => recipeSaveService.updateIngredientProportion(ingredient.id, {
                            unitWeight: Number(e.target.value) || 1,
                        })}
                    />
                </label>
                </>
            ) : (
                <>
                    <label className="block__text recipe__form-label recipe__add-label">
                        <span className="product__form-label_text">{i18n.t('app.page.recipe.amountKind')}</span>
                        <Select
                            fullWidth
                            className="mt-0"
                            value={ingredient.amountKind || 'to_taste'}
                            onChange={(value) => recipeSaveService.updateIngredientProportion(ingredient.id, {
                                amountKind: value,
                                amountValue: value === 'to_taste' ? null : (ingredient.amountValue ?? 1),
                            })}
                            options={AMOUNT_KINDS.map((kind) => ({
                                value: kind,
                                label: i18n.t(`app.page.recipe.amountKind.${kind}`),
                            }))}
                        />
                    </label>
                    {ingredient.amountKind && ingredient.amountKind !== 'to_taste' ? (
                        <label className="block__text recipe__form-label recipe__add-label">
                            <span className="product__form-label_text">{i18n.t('app.page.recipe.amountValue')}</span>
                            <Input
                                fullWidth
                                className="mt-0"
                                type="number"
                                min={0}
                                step={0.1}
                                value={ingredient.amountValue ?? 1}
                                onChange={(e) => recipeSaveService.updateIngredientProportion(ingredient.id, {
                                    amountValue: Number(e.target.value) || 0,
                                })}
                            />
                        </label>
                    ) : null}
                </>
            )}
            <FormsHandler selectWithTokensManager={createFormsIngredientService(ingredient?.ingredientParts[0]?.productCode, ingredient.id)} />
        </li> 
    );
};

export default IngredientsListItem;
